import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/main.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './config/locales'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

